export const en_GB = {
  // Header/Sidebar
  user: 'User',
  users: 'Users',
  installations: 'Installations',
  settings: 'Settings',
  certificate: 'Certificate',
  main_settings: 'Main Settings',
  terminology: 'Terminology',
  equipment: 'Equipment',
  security: 'Security',
  tenants: 'Tenants',
  collapse: 'Collapse',
  branding: 'Branding',
  sign_out: 'Sign Out',
  hello: 'Hello!',

  // Misc
  save: 'Save',
  cancel: 'Cancel',

  // Installation Table
  status: 'Status',
  clear: 'Clear',
  date: 'Date',
  technician: 'Technician',
  customer_phone: 'Customer Phone',
  address: 'Address',
  unit: 'Unit',
  city: 'City',
  state_prov: 'State/Prov',
  rooms_tested: 'Rooms Tested',
  tested: 'Tested',
  plan: 'Plan',
  rows_per_page: 'Rows per page: ',
  recommended_short: 'Recomm.',
  notes: 'Notes',

  // Certificate Branding Tab
  current_image: 'Current Image: ',
  using_default_logo: 'Using Default Logo',
  new_image: 'New Image',
  branding_loading_error: 'Branding loading error. Please try again later.',
  upload_new_image: 'Upload New Image',
  clear_custom_image: 'Clear Custom Image',
  clear_custom_color: 'Clear Custom Color',
  brand_color: 'Brand Color',
  header_message: 'Header Message',
  header_education_message: 'Header Education Message',
  footer_education_message: 'Footer Education Message',
  preview: 'Preview',

  // Certificate Headers
  congrats_message: "Your WiFi installation is complete and has been certified by RouteThis!",
  installation_details: "Installation Details",
  wireless_speed_test: "Wireless Speed Test",
  wireless_performance: "Wireless Performance",
  wireless_speed_test_hidespeedtest: "WiFi Internet Speed Test",
  photos: "Photos",
  signal_maps: "Signal Maps",
  wifi_information: 'WiFi Information',

  // Certificate Room Names
  singular_room: "Room",
  room_type_bathroom: "Toilet",
  room_type_bedroom: "Bedroom",
  room_type_dining_room: "Dining Room",
  room_type_entry_or_hall: "Entry/Hall",
  room_type_garage: "Garage",
  room_type_kitchen: "Kitchen",
  room_type_living_room: "Sitting Room",
  room_type_office: "Office",
  room_type_other: "Other",

  // Pod Name
  pod_1: "Mesh Pod",
  pod_2: "Access Point",
  pod_3: "Mesh Node",
  pod_4: "Mesh Puck",
  pod_5: "Beacon",
  pod_6: "Mesh Pod",
  pods_1: "Mesh Pods",
  pods_2: "Access Points",
  pods_3: "Mesh Nodes",
  pods_4: "Mesh Pucks",
  pods_5: "Beacons",
  pods_6: "Mesh Pods",

  // Router Name
  router_1: "Router",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Router",

  // Level Name
  level_1: "Level",
  level_2: "Floor",
  levels_1: "Levels",
  levels_2: "Floors",

  // a11y Labels
  go_to_homepage: 'Go To Homepage',
  edit_user_x: 'Edit User [X]',
  open_certificate_for_addr: 'Open Certificate For [ADDR]',
  clear_all_filters: 'clear all filters',
  expand_sidebar: 'Expand Sidebar',
  current_tenant_branding_image: 'Current Tenant Branding Image',
  new_tenant_branding_image: 'New Tenant Branding Image',

  // Certificate Pod Info
  recommended: "Recommended",
  installed: "Installed",
  total: "Total",

  // Certificate Signal Table
  front_building: "Front of Building",
  speed: "Speed",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Link",
  frequency_short: "Freq.",
  frequency_description: "MHz",
  channel_short: "Ch.",

  // Certificate Legend
  legend: "Legend",
  measured_speed: "Measured Speed",
  measured_speed_description: "Mbps",
  plan_speed: "Plan Speed",

  // Certificate Speedtest Result
  speedtest_passed: "Speed is within the expected range for most mobile devices. Not all wireless devices are capable of reaching maximum plan speed. See below for individual room tests.",
  speedtest_failed: "Tested on a phone or tablet. Not all wireless devices are capable of reaching maximum plan speed. See below for individual room tests.",
}